<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="仪表列表">
        <div class="table-wrap">
          <el-table border v-if="excel_list2&&excel_list2.length" v-loading="loading" :data="pageData.list" height="calc( 100vh - 100px )">
            <el-table-column
              type="index"
              width="50" label="序号">
            </el-table-column>

            <el-table-column label="操作" align="center" width="80">
              <template slot-scope="scope">
                <span :style="{color:(scope.row.id?'#038dce':'#2fb902')}">{{scope.row.id?'修改':'新增'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="仪表编号" align="center" width="100"></el-table-column>
            <el-table-column prop="meter_level" label="仪表等级" align="center" width="80"></el-table-column>
            <el-table-column prop="parent_number" label="上级编号" align="center" width="150"></el-table-column>
            <el-table-column prop="name" label="仪表名称" align="center" width="200"></el-table-column>
            <el-table-column prop="house_name" label="所在房产" align="center" width="320"></el-table-column>
            <el-table-column prop="meter_type_name" label="仪表类型" align="center" width="90"></el-table-column>
            <el-table-column prop="meter_energy_name" label="能耗类型" align="center" width="90"></el-table-column>
            <el-table-column prop="meter_nature_name" label="仪表性质" align="center" width="90"></el-table-column>
            <el-table-column prop="charging_standard_name" label="收费标准" align="center" width="180"></el-table-column>
            <el-table-column prop="start_number" label="初始读数" align="center" width="120"></el-table-column>
            <el-table-column prop="magnification" label="倍率" align="center" width="80"></el-table-column>
            <el-table-column prop="install_time" label="安装日期" align="center" width="200"></el-table-column>
            <el-table-column prop="remarks" label="备注" align="center" width="100"></el-table-column>
            <el-table-column prop="position" label="位置" align="center" width="100"></el-table-column>
            <el-table-column prop="id" label="主表编号" align="center" width="100"></el-table-column>
          </el-table>
          <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
            <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="关系图" v-if="master_id==40">
<!--        <MeterViewDiagram v-if="excel_list2.length>0" :excel_list="excel_list2" />-->
        <MeterViewMapList :batch_number="batch_number" />
      </el-tab-pane>
      <el-tab-pane label="数据校正" :disabled="isDisabled">
        <ImportMeter v-if="!isDisabled" @meterImport="meterImport" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MeterViewDiagram from "./MeterViewDiagram";
import ImportMeter from "./components/ImportMeter";
import MeterViewMapList from "./MeterViewMapList";
export default {
  name: "MeterViewCache",
  components: {MeterViewMapList, ImportMeter, MeterViewDiagram},
  data(){
    return{
      excel_list2:[],
      loading:false,
      batch_number:'',
      task_id:0,
      master_id:0,
      flowData:null,
      isDisabled:true,
      pageData:{
        list:[],
        total: 0,
        pageSize: 15,
        page: 1
      },
    }
  },
  created() {
    this.batch_number=this.$route.query.batch_number;
    this.task_id=this.$route.query.task_id?(this.$route.query.task_id)*1:0;
    this.master_id=this.$route.query.master_id;
  },
  mounted() {
    this.getFlowData()
    this.getList()
  },
  methods:{
    getList(){
      const that=this;
      ERP.postRequest({
        url:"admin/Meter/meterImportExcelCacheView",
        data:{
          batch_number:that.batch_number,
          task_id:that.task_id,
        },
      },ret=>{
        if(ret.code){
          that.excel_list2=ret.data;
          that.pageData.total=that.excel_list2.length
          that.pageChange(1)
        }
      })
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i
      let list=reObject(that.excel_list2)
      that.pageData.list=list.splice((that.pageData.page-1)*that.pageData.pageSize,that.pageData.pageSize);
    },
    meterImport(batch_number){
      this.batch_number=batch_number;
      this.excel_list2=[];
      this.getList();
    },
    getFlowData(){
      const that=this;
      if(!that.task_id){
        that.isDisabled=false;
      }
      that.task_id&&ERP.postRequest({
        url:"admin/Meter/getFlowData",
        data:{
          task_id:that.task_id,
        },
      },ret=>{
        if(ret.code){
          // that.excel_list2=ret.data;
          this.flowData=ret.data
          if([11,10].includes(ret.data.status*1)){
            that.isDisabled=false;
          }
        }else {
          this.$message.error(ret.msg||'数据异常')
        }
      })
    }

  },

}
function reObject(item){
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/MeterViewCache.vue